import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './TrustDataDownloadBtn.css';
import BackButton from '../BackButton';
import html2pdf from 'html2pdf.js';
import axiosInstance from '../../interceptor/axiosInstance';
import Swal from "sweetalert2";

// Skeleton Loader Component
const SkeletonLoader = () => (
  <div className="trust-skeleton-container">
    <div className="trust-skeleton-header"></div>
    <div className="trust-skeleton-summary">
      <div className="trust-skeleton-image"></div>
      <div className="trust-skeleton-info">
        <div className="trust-skeleton-line"></div>
        <div className="trust-skeleton-line"></div>
      </div>
    </div>
    <div className="trust-skeleton-score"></div>
    <div className="trust-skeleton-cards">
      {Array.from({ length: 5 }).map((_, idx) => (
        <div key={idx} className="trust-skeleton-card"></div>
      ))}
    </div>
  </div>
);

// Empty State Component
const EmptyState = () => (
  <div className="trust-empty-state">
    <div className="trust-empty-icon">📊</div>
    <h3 className="trust-empty-title">No Trust Data Available</h3>
    <p className="trust-empty-message">
      Unable to load proctoring data for this test attempt.
      <br />
      Please check if the test was completed with proctoring enabled.
    </p>
  </div>
);

const TrustDataDisplay = () => {
  // const location = useLocation();
  // // const { reportData } = location.state || {};

    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);
    const userId = queryParams.get("user_id"); // Corrected from "attemptId" to "user_id"
    const testId = queryParams.get("testId");
    
  const [answerData, setAnswerData] = useState([]);

  const [audio, setAudio] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [currentAudioUrl, setCurrentAudioUrl] = useState('');
  const contentRef = useRef(null);  // Ref for printing
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [downloadingPDF, setDownloadingPDF] = useState(false);

  useEffect(() => {
    if (userId && testId) {
      setLoading(true);  // Start loading state
  
      axiosInstance
        .post('reports/test_summary_report/', {
          test_id: testId,
          user_id: userId,
        })
        .then((response) => {
          if (response.data && response.data.data) {
            setAnswerData(response.data.data);  // Safely set the data
          } else {
            setError('No data found in response. Please try again.');
          }
  
          setLoading(false);  // Stop loading state
        })
        .catch((error) => {
          setError('Failed to load answer data. Please try again.');
          setLoading(false);
        });
    }
  }, [userId, testId]);  

  const link = process.env.REACT_APP_PANEL_BASE_URL

  const buildTrustReportFilename = () => {
    const sanitizePart = (value) =>
      String(value ?? '')
        .trim()
        .replace(/[<>:\"/\\|?*\x00-\x1F]+/g, ' ')
        .replace(/\s+/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_+|_+$/g, '');

    const studentName = sanitizePart(answerData?.user_name || 'Student') || 'Student';

    const examDateSource = answerData?.start_time || answerData?.end_time || '';
    let examDate = 'Exam_Date';

    if (examDateSource) {
      const parsedDate = new Date(examDateSource);
      if (!Number.isNaN(parsedDate.getTime())) {
        examDate = parsedDate.toISOString().slice(0, 10);
      } else {
        const rawDatePart = String(examDateSource).split(/[T ]/)[0];
        examDate = sanitizePart(rawDatePart) || 'Exam_Date';
      }
    }

    return `${studentName}_${examDate}_Trust_Report.pdf`;
  };

  // const handleDownloadPDF = async () => {
  //   if (loading || !contentRef.current) {
  //     Swal.fire("Please wait", "Content is still loading...", "info");
  //     return;
  //   }
  
  //   const element = contentRef.current;
  //   element.classList.add("pdf-download");
  
  //   // Set width to fit PDF (temporarily)
  //   const originalStyle = element.getAttribute("style") || "";
  //   element.style.width = "800px";
  
  //   // Convert all images inside element to Base64 for embedding
  //   const images = element.querySelectorAll('img');
  //   const convertToBase64 = async (img) => {
  //     const src = img.src;
  //     if (src.startsWith('data:')) return; // Already Base64
  //     try {
  //       const res = await fetch(src, { mode: 'cors' });
  //       const blob = await res.blob();
  //       return await new Promise((resolve, reject) => {
  //         const reader = new FileReader();
  //         reader.onloadend = () => resolve(reader.result);
  //         reader.onerror = reject;
  //         reader.readAsDataURL(blob);
  //       });
  //     } catch (err) {
  //       console.warn("Image to Base64 failed:", err);
  //     }
  //   };
  
  //   for (const img of images) {
  //     const base64 = await convertToBase64(img);
  //     if (base64) img.src = base64;
  //   }
  
  //   // Use html2pdf to generate and download PDF
  //   html2pdf()
  //     .set({
  //       margin: [10, 10, 10, 10],
  //       filename: `Trust_Report_${answerData?.user_name || "Report"}.pdf`,
  //       html2canvas: {
  //         scale: 2,
  //         useCORS: true,
  //         scrollX: 0,
  //         scrollY: 0,
  //       },
  //       jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' },
  //     })
  //     .from(element)
  //     .save()
  //     .then(() => {
  //       element.classList.remove("pdf-download");
  //       element.setAttribute("style", originalStyle); // restore
  //     })
  //     .catch((err) => {
  //       Swal.fire("Error", "Failed to generate PDF.", "error");
  //       console.error("PDF error:", err);
  //       element.classList.remove("pdf-download");
  //       element.setAttribute("style", originalStyle); // restore
  //     });
  // };
  const handleDownloadPDF = async () => {
    if (loading || !contentRef.current) {
      Swal.fire("Please wait", "Content is still loading...", "info");
      return;
    }
  
    setDownloadingPDF(true);
  
    const formData = new FormData();
    formData.append("test_id", testId);
    formData.append("user_id", userId);
    formData.append("type", "file");
  
    try {
      const response = await axiosInstance.post("reports/test_summary_report/", formData, {
        responseType: "blob",
      });
  
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = buildTrustReportFilename();
      document.body.appendChild(a);
      a.click();
      a.remove();
  
      Swal.fire("Download Complete", "Your summary report has been downloaded.", "success");
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.detail ||
        "An error occurred while downloading the PDF.";
      Swal.fire("Download Failed", errorMessage, "error");
    } finally {
      setDownloadingPDF(false);
    }
  };
  
  const closePopup = () => {
    setIsPopupOpen(false);
    if (audio) {
      audio.pause();
    }
  };

  const openPopup = (event) => {
    if (event.type === 'noise_detection' && event.image) {
      setCurrentAudioUrl(event.image); // Assuming `event.image` is the audio URL
      // playAudio(event.image);
    } else {
      setCurrentAudioUrl('');
    }
    setIsPopupOpen(true);
  };

  return (
    <div className="trust-page-container">
      {loading ? (
        <SkeletonLoader />
      ) : error ? (
        <div className="trust-error-state">
          <div className="trust-error-icon">⚠️</div>
          <h3 className="trust-error-title">Error Loading Data</h3>
          <p className="trust-error-message">{error}</p>
        </div>
      ) : !answerData || Object.keys(answerData).length === 0 ? (
        <EmptyState />
      ) : (
        <div className="trust-content-wrapper" ref={contentRef}>
          {/* Header */}
          <div className="trust-page-header">
            <div className="trust-page-header-left">
              <BackButton />
              <div>
                <h1 className="trust-page-title">
                  {answerData.start_time} Online MCQ Test
                </h1>
                <p className="trust-page-subtitle">{answerData.test_name}</p>
              </div>
            </div>
            <div className="trust-user-greeting">
              Hey, {answerData.user_name} 👋
            </div>
          </div>

          {/* Proctoring Summary */}
          <div className="trust-proctoring-section">
            <h2 className="trust-section-title">Proctoring Summary</h2>
            <p className="trust-section-subtitle">
              View the test taker's proctoring report
            </p>
          </div>

          {/* User Info Section */}
          <div className="trust-user-info-section">
            <div className="trust-user-image-container">
              <img
                src={answerData.initial_image || process.env.REACT_APP_DEFAULT_AVATAR}
                className="trust-user-image"
                alt="User"
              />
            </div>

            <div className="trust-info-grid">
              <div className="trust-info-card">
                <p className="trust-info-label">STARTED AT</p>
                <p className="trust-info-value">{answerData.start_time}</p>
              </div>

              <div className="trust-info-card">
                <p className="trust-info-label">SUBMITTED AT</p>
                <p className="trust-info-value">{answerData.end_time}</p>
              </div>

              <div className="trust-info-card">
                <p className="trust-info-label">BROWSER (DEVICE)</p>
                <p className="trust-info-value">Chrome (desktop)</p>
              </div>

              <div className="trust-info-card trust-info-card-action">
                <button
                  className="trust-download-btn"
                  onClick={handleDownloadPDF}
                  disabled={downloadingPDF}
                >
                  {downloadingPDF ? '⏳ Downloading...' : '📥 Download All Response'}
                </button>
              </div>
            </div>
          </div>

          {/* Trust Score Display */}
          <div className="trust-score-section">
            <div className={`trust-score-display ${answerData.trust_score < 80 ? 'trust-score-low' : 'trust-score-high'}`}>
              {answerData.trust_score}%
            </div>
            <div className="trust-score-label">
              <span>Trust Score</span>
              <img
                width="20"
                height="20"
                src="https://img.icons8.com/ios/50/737373/help--v1.png"
                alt="help"
                className="trust-help-icon"
              />
            </div>
          </div>

          {/* Metrics Cards */}
          <div className="trust-metrics-section">
            <div className="trust-metric-card">
              <div className="trust-metric-icon">
                <img
                  width="24"
                  height="24"
                  src="https://img.icons8.com/material-outlined/24/737373/microphone.png"
                  alt="microphone"
                />
              </div>
              <h4 className="trust-metric-title">Noise Detected</h4>
              <p className="trust-metric-value">{answerData.noise_detection_count || 0}</p>
            </div>

            <div className="trust-metric-card">
              <div className="trust-metric-icon">
                <img
                  width="24"
                  height="24"
                  src="https://img.icons8.com/material-outlined/24/737373/conference-call.png"
                  alt="multiple face"
                />
              </div>
              <h4 className="trust-metric-title">Multiple Face</h4>
              <p className="trust-metric-value">{answerData.multi_face_count || 0}</p>
            </div>

            <div className="trust-metric-card">
              <div className="trust-metric-icon">
                <img
                  width="24"
                  height="24"
                  src="https://img.icons8.com/material-outlined/24/737373/tab.png"
                  alt="tab switch"
                />
              </div>
              <h4 className="trust-metric-title">Tab Switch</h4>
              <p className="trust-metric-value">{answerData.tab_switched_count || 0}</p>
            </div>

            <div className="trust-metric-card">
              <div className="trust-metric-icon">
                <img
                  width="24"
                  height="24"
                  src="https://img.icons8.com/material-outlined/24/737373/invisible.png"
                  alt="no face"
                />
              </div>
              <h4 className="trust-metric-title">No Face Detected</h4>
              <p className="trust-metric-value">{answerData.no_face_count || 0}</p>
            </div>

            <div className="trust-metric-card">
              <div className="trust-metric-icon">
                <img
                  width="24"
                  height="24"
                  src="https://img.icons8.com/material-outlined/24/737373/full-screen.png"
                  alt="fullscreen"
                />
              </div>
              <h4 className="trust-metric-title">Exited Full Screen</h4>
              <p className="trust-metric-value">{answerData.exited_fullscreen_count || 0}</p>
            </div>
          </div>

          {/* Events Table */}
          <div className="trust-table-wrapper">
            <table className="trust-events-table">
              <thead>
                <tr>
                  <th>Duration (seconds)</th>
                  <th>Date Time</th>
                  <th>Type</th>
                  <th>Image</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(answerData?.events) && answerData.events.length > 0 ? (
                  answerData.events.map((event, index) => (
                    <tr key={index}>
                      <td>{event.duration === "N/A" ? "0.00" : event.duration}</td>
                      <td className="trust-td-date">{event.time}</td>
                      <td>
                        <span className="trust-event-badge">{event.type}</span>
                      </td>
                      <td className="trust-td-image">
                        {event.type === 'noise_detection' ? (
                          <button
                            className="trust-audio-btn"
                            onClick={() => openPopup(event)}
                          >
                            <img
                              src="https://img.icons8.com/material-outlined/24/ffffff/microphone.png"
                              alt="Play Audio"
                            />
                          </button>
                        ) : (
                          <img
                            className="trust-event-image"
                            src={event.image}
                            alt={event.text || 'Event'}
                          />
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="trust-no-data">No events found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Audio Popup Modal */}
      {isPopupOpen && (
        <div className="trust-modal-overlay" onClick={closePopup}>
          <div className="trust-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="trust-modal-close" onClick={closePopup}>
              ✕
            </button>
            <h4 className="trust-modal-title">Audio Record</h4>
            {currentAudioUrl ? (
              <div className="trust-audio-player">
                <audio controls>
                  <source src={currentAudioUrl} type="audio/mp3" />
                  Your browser does not support the audio element.
                </audio>
              </div>
            ) : (
              <p className="trust-modal-message">No recording was made.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TrustDataDisplay;
